import { useMount } from "app/custom-hooks/useMount";
import type React from "react";
import { useDispatch } from "react-redux";
import { getDynamicsStatusThunk } from "../../store/effects/dynamics/status";

const withDynamicsStatusCall = <P extends Record<string, unknown>>(Component: React.ComponentType<P>) => {
    return function WrappedWithDynamicsCall(props: P) {
        const dispatch = useDispatch();

        useMount(() => {
            dispatch(getDynamicsStatusThunk());
        });

        return <Component {...props} />;
    };
};

export default withDynamicsStatusCall;
